function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "#957FFF",
  d: "M8.5 11C3.305 11 .724 6.988.082 5.817a.656.656 0 010-.634C.724 4.013 3.305 0 8.5 0c5.195 0 7.776 4.012 8.418 5.183.11.198.11.436 0 .634C16.276 6.987 13.695 11 8.5 11zm0-9a3.5 3.5 0 100 7 3.5 3.5 0 000-7zm0 5.75a2.25 2.25 0 110-4.5 2.25 2.25 0 010 4.5z"
});

var SvgPageviewIcon = function SvgPageviewIcon(props) {
  return React.createElement("svg", _extends({
    width: 17,
    height: 11,
    viewBox: "0 0 17 11"
  }, props), _ref);
};

export default SvgPageviewIcon;